var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3A2674",
    d: "M14.273 8.087c.038-1.332-.615-2.37-1.532-3.27a.225.225 0 0 1-.063-.28a.21.21 0 0 1 .239 0a4.04 4.04 0 0 1 1.785 1.438c.442.64.688 1.396.708 2.174l-.016.153c-.05.516-.177 1.85-.97 2.517a.53.53 0 0 1-.71-.144a.505.505 0 0 1-.044-.563a4 4 0 0 0 .603-2.025m-3.956 9.883a8.4 8.4 0 0 0 1.036 1.219c.094.094.094.188.044.231c-.044.05-.138.094-.189.05a4.19 4.19 0 0 1-2.355-2.625c-.333-1.157-.094-2.87.848-3.657a.53.53 0 0 1 .71.143a.436.436 0 0 1 0 .563a3.99 3.99 0 0 0-.094 4.076m4.113-5.088c.576.689.921 1.542.986 2.438v.006a4.1 4.1 0 0 1-.615 2.488a5.9 5.9 0 0 1-1.79 1.637a.183.183 0 0 1-.283-.043a.17.17 0 0 1-.028-.128a.17.17 0 0 1 .072-.11a4.7 4.7 0 0 0 1.37-1.688c.284-.63.365-1.334.232-2.012a2.8 2.8 0 0 0-.892-1.688a10 10 0 0 0-1.79-1.22a8.1 8.1 0 0 1-2.022-1.45a4.5 4.5 0 0 1-.754-1.125a4.1 4.1 0 0 1-.333-1.312a3.95 3.95 0 0 1 .666-2.532a4.23 4.23 0 0 1 1.834-1.594a.19.19 0 0 1 .232-.013c.088.063.088.219 0 .294a5.2 5.2 0 0 0-1.319 1.732a3.36 3.36 0 0 0-.232 1.919a3.14 3.14 0 0 0 .898 1.637a11 11 0 0 0 1.79 1.264c.732.396 1.4.902 1.978 1.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgi);
export default __webpack_public_path__ + "static/media/agi.a43a97c459b8e4e4743b2c49823a3137.svg";
export { ForwardRef as ReactComponent };